import { memo } from 'react';
import { useSelector } from 'src/store/react';
import { selectAuthenticated } from 'src/store/selectors';
import SaveJobSectionForSignedIn from './components/SaveJobSectionForSignedIn/SaveJobSectionForSignedIn';
import SaveJobSectionForSignedOut from './components/SaveJobSectionForSignedOut/SaveJobSectionForSignedOut';
import type { ChaliceJob } from '@seek/chalice-types';
import type { SolMetadata } from '@seek/sol-js';

export type JobForSavedJob = Pick<ChaliceJob, 'id' | 'tracking'> & {
  solMetadata?: SolMetadata;
};

export interface SaveJobSectionProps {
  jobId: string;
  jobTracking: ChaliceJob['tracking'];
  withAppliedTick: boolean;
}

const SaveJob = ({
  jobId,
  jobTracking,
  withAppliedTick,
}: SaveJobSectionProps) => {
  const authenticated = useSelector(selectAuthenticated);

  return authenticated ? (
    <SaveJobSectionForSignedIn
      jobId={jobId}
      jobTracking={jobTracking}
      withAppliedTick={withAppliedTick}
    />
  ) : (
    <SaveJobSectionForSignedOut jobId={jobId} />
  );
};

export default memo(SaveJob);
